import { createSlice } from '@reduxjs/toolkit';

import { fetchHairyChartData, fetchHairyChartSelections } from './thunks';
import { HairyChartAnalysisState } from './types';

const initialState: HairyChartAnalysisState = {
  selections: { data: null, loading: false, error: null },
  chart: { data: null, loading: false, error: null },
};

const hairyChartAnalysisSlice = createSlice({
  name: 'hairyChartAnalysis',
  initialState,
  reducers: {
    clearHairyChart: (state) => {
      state.chart = { data: null, loading: false, error: null };
    },
    clearHairyChartSelections: (state) => {
      state.selections = { data: null, loading: false, error: null };
      state.chart = { data: null, loading: false, error: null };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchHairyChartSelections.pending, (state) => {
        state.selections.loading = true;
        state.selections.error = null;
      })
      .addCase(fetchHairyChartSelections.fulfilled, (state, action) => {
        state.selections.loading = false;
        state.selections.data = action.payload;
      })
      .addCase(fetchHairyChartSelections.rejected, (state, action) => {
        state.selections.loading = false;
        state.selections.error = action.payload ?? 'Something went wrong';
      })
      .addCase(fetchHairyChartData.pending, (state) => {
        state.chart.loading = true;
        state.chart.error = null;
      })
      .addCase(fetchHairyChartData.fulfilled, (state, action) => {
        state.chart.loading = false;
        state.chart.data = action.payload;
      })
      .addCase(fetchHairyChartData.rejected, (state, action) => {
        state.chart.loading = false;
        state.chart.error = action.payload ?? 'Something went wrong';
      });
  },
});

export const { clearHairyChart, clearHairyChartSelections } =
  hairyChartAnalysisSlice.actions;

export default hairyChartAnalysisSlice.reducer;
